// extracted by mini-css-extract-plugin
export default {"GenerateButton":"generateaudio_GenerateButton__CpXul"};